module.exports = __webpack_public_path__ + "img/title-bg.833d343.png";